import React, { useContext } from 'react';
import { useDeviationViewContext } from '../../../Context';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getDeviationType, isLegacyStatus } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
import DesktopActionBar from '../../variants/DesktopActionBar';
import MobileActionBar from '../../variants/MobileActionBar';
import ExpandActionBar from '../../variants/ExpandActionBar';
import SimpleActionBar from '../../variants/SimpleActionBar';
import CommissionActionBar from '../../variants/CommissionActionBar';
import TierActionBar from '../../variants/TierActionBar';
import StashActionBar from '../../variants/StashActionBar';
const ActionBarContent = (props)=>{
    const { isFullscreen } = useDeviationViewContext();
    const isMobile = useContext(MobileContext);
    const { deviation } = props;
    const deviationType = getDeviationType(deviation);
    if (!deviation.isPublished) {
        return /*#__PURE__*/ React.createElement(StashActionBar, props);
    }
    if (isFullscreen) {
        return /*#__PURE__*/ React.createElement(ExpandActionBar, props);
    }
    if (isMobile) {
        return /*#__PURE__*/ React.createElement(MobileActionBar, props);
    }
    if (deviationType === DeviationTypes.STATUS && !isLegacyStatus(deviation)) {
        return /*#__PURE__*/ React.createElement(DesktopActionBar, props);
    }
    switch(deviationType){
        case DeviationTypes.STATUS:
        case DeviationTypes.POLL:
            return /*#__PURE__*/ React.createElement(SimpleActionBar, props);
        case DeviationTypes.COMMISSION:
            return /*#__PURE__*/ React.createElement(CommissionActionBar, props);
        case DeviationTypes.TIER:
            return /*#__PURE__*/ React.createElement(TierActionBar, props);
        default:
            return /*#__PURE__*/ React.createElement(DesktopActionBar, props);
    }
};
ActionBarContent.displayName = 'ActionBarContent';
export default ActionBarContent;

//# sourceMappingURL=ActionBarContent.js.map